import type { QuoteResponse } from '@on3/api';
import {
  On3IconQuotationMark,
  On3IconSportsQuotes,
  On3IconTwitterRed,
} from '@on3/icons';
import { TextLink } from 'components/UI/Link/TextLink';
import { Text } from 'components/UI/Typography/Text';
import Link from 'next/link';

import styles from './ProfileQuote.module.scss';

interface IProfileQuoteProps {
  list?: QuoteResponse[] | null;
  slug?: string;
}
export const ProfileQuote = ({ list, slug }: IProfileQuoteProps) => {
  const { body } = list?.[0] ?? {};
  const showAllQuotesLink = list && list?.length > 1;

  return (
    <section className={styles.container}>
      <header className={styles.headerWrapper}>
        <On3IconSportsQuotes height={16} width={152} />
        <div className={styles.twitterWrapper}>
          <On3IconTwitterRed height={10} width={16} />
          <Link
            className={styles.twitterText}
            href="https://twitter.com/SportsQuotesOn3"
            rel="noopener noreferrer"
            target="_blank"
          >
            <Text color="primary" variant="caption">
              @sportsquoteson3
            </Text>
          </Link>
        </div>
      </header>
      <div className={styles.quotesWrapper}>
        <On3IconQuotationMark height={47} />
        <Text className={styles.quotes}>{body}</Text>
      </div>
      {showAllQuotesLink && (
        <TextLink
          className={styles.allQuotesLink}
          href={`/db/coach/${slug}/quotes/`}
        >
          Read All Quotes
        </TextLink>
      )}
    </section>
  );
};
